// extracted by mini-css-extract-plugin
export default {"container":"style_container__Y0-hI","badge":"style_badge__+JhNw","containerLoad":"style_containerLoad__V37zy","visible":"style_visible__glIfh"};